import CurrencyDeterminer from "@/module/Form/Currency/CurrencyDeterminer";

export default class ChoiceCurrencyDeterminer implements CurrencyDeterminer {
  private readonly currencies: Array<string>;

  constructor(currencies: Array<string>) {
    this.currencies = currencies;
  }

  determinate(selectedCurrency: string | null): string {
    let currency = this.currencies.find((item) => {
      return item === selectedCurrency;
    });

    if (currency === undefined) {
      currency = this.currencies[0];
    }

    return currency;
  }
}
